export interface SiteSettings {
  creator_creek_live: boolean;
  announcement_enabled: boolean;
  announcement_text: string;
  announcements: string[];
  announcement_bg_color: string;
  announcement_text_color: string;
  promo_buy2get1_enabled: boolean;
  nav_visibility: Record<string, boolean>;
  header_bg_color: string;
  header_text_color: string;
  header_logo_color: string;
  promo_captcha_enabled: boolean;
  promo_captcha_code: string;
  promo_marquee_bg_color: string;
  promo_marquee_text_color: string;
  promo_marquee_text: string;
  feature_marquee_bg_color: string;
  feature_marquee_text_color: string;
}

export const DEFAULT_SITE_SETTINGS: SiteSettings = {
  creator_creek_live: false,
  announcement_enabled: true,
  announcement_text: "Free shipping on orders over $75 — Premium Lifestyle Headwear.",
  announcements: [],
  announcement_bg_color: "#2A1510",
  announcement_text_color: "#F5EFE2",
  promo_buy2get1_enabled: true,
  nav_visibility: {},
  header_bg_color: "#F5EFE2",
  header_text_color: "#2A1510",
  header_logo_color: "#2A1510",
  promo_captcha_enabled: true,
  promo_captcha_code: "BUY2GET1",
  promo_marquee_bg_color: "#2A1510",
  promo_marquee_text_color: "#F5EFE2",
  promo_marquee_text: "BUY 2 GET 1 FREE",
  feature_marquee_bg_color: "#2A1510",
  feature_marquee_text_color: "#F5EFE2",
};

type SiteSettingRow = {
  key: string;
  value: unknown;
};

export function buildSiteSettings(rows: SiteSettingRow[] | null | undefined): SiteSettings {
  const map: Record<string, unknown> = {};
  for (const row of rows ?? []) map[row.key] = row.value;

  return {
    creator_creek_live: (map.creator_creek_live as boolean) ?? DEFAULT_SITE_SETTINGS.creator_creek_live,
    announcement_enabled: (map.announcement_enabled as boolean) ?? DEFAULT_SITE_SETTINGS.announcement_enabled,
    announcement_text: (map.announcement_text as string) ?? DEFAULT_SITE_SETTINGS.announcement_text,
    announcements: Array.isArray(map.announcements) ? (map.announcements as string[]) : DEFAULT_SITE_SETTINGS.announcements,
    announcement_bg_color: (map.announcement_bg_color as string) ?? DEFAULT_SITE_SETTINGS.announcement_bg_color,
    announcement_text_color: (map.announcement_text_color as string) ?? DEFAULT_SITE_SETTINGS.announcement_text_color,
    promo_buy2get1_enabled: (map.promo_buy2get1_enabled as boolean) ?? DEFAULT_SITE_SETTINGS.promo_buy2get1_enabled,
    nav_visibility: (map.nav_visibility as Record<string, boolean>) ?? DEFAULT_SITE_SETTINGS.nav_visibility,
    header_bg_color: (map.header_bg_color as string) ?? DEFAULT_SITE_SETTINGS.header_bg_color,
    header_text_color: (map.header_text_color as string) ?? DEFAULT_SITE_SETTINGS.header_text_color,
    header_logo_color: (map.header_logo_color as string) ?? (map.header_text_color as string) ?? DEFAULT_SITE_SETTINGS.header_logo_color,
    promo_captcha_enabled: (map.promo_captcha_enabled as boolean) ?? DEFAULT_SITE_SETTINGS.promo_captcha_enabled,
    promo_captcha_code: (map.promo_captcha_code as string) ?? DEFAULT_SITE_SETTINGS.promo_captcha_code,
    promo_marquee_bg_color: (map.promo_marquee_bg_color as string) ?? DEFAULT_SITE_SETTINGS.promo_marquee_bg_color,
    promo_marquee_text_color: (map.promo_marquee_text_color as string) ?? DEFAULT_SITE_SETTINGS.promo_marquee_text_color,
    promo_marquee_text: (map.promo_marquee_text as string) ?? DEFAULT_SITE_SETTINGS.promo_marquee_text,
    feature_marquee_bg_color: (map.feature_marquee_bg_color as string) ?? DEFAULT_SITE_SETTINGS.feature_marquee_bg_color,
    feature_marquee_text_color: (map.feature_marquee_text_color as string) ?? DEFAULT_SITE_SETTINGS.feature_marquee_text_color,
  };
}